import React from "react";
import Style from "./Warning.module.css";

import { RiDeleteBin6Line } from "react-icons/ri";
import { useDeleteMessage } from "../../../hooks/useDeleteChat";
import { Loader } from "lucide-react";

const DeletionMsgConfirm = ({
  onClose,
  handleDeleteMessage,
  messageId,
  chatUniqueId,
}) => {
  const { isUpdating, deleteMessage } = useDeleteMessage();
  const handleDelete = async () => {
    try {
      await deleteMessage(messageId, chatUniqueId);
      handleDeleteMessage(messageId, chatUniqueId);
      onClose();
    } catch {}
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <div className={Style.WarningdeleteConfirmation}>
      <div className={Style.WarningconfirmationCard}>
        <>
          <div className={Style.WarningiconContainer}>
            <RiDeleteBin6Line size={50} color="red" />
          </div>

          <h3>Confirm Deletion</h3>
          <p className={Style.Warrningpara}>This action cannot be undone.</p>

          <div className={Style.WarningbuttonGroup}>
            <button className={Style.WarningcancelBtn} onClick={handleCancel}>
              Cancel
            </button>
            <button className={Style.WarningdeleteBtn} onClick={handleDelete}>
              {isUpdating ? <Loader /> : "Delete"}
            </button>
          </div>
        </>
      </div>
    </div>
  );
};

export default DeletionMsgConfirm;
